"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countItemsOnAxes = exports.countBucketItems = void 0;
// (C) 2019-2020 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_charts_1 = require("@gooddata/sdk-ui-charts");
function countBucketItems(insight) {
    if (!insight) {
        return {
            viewByItemCount: 0,
            measureItemCount: 0,
            secondaryMeasureItemCount: 0,
        };
    }
    var viewBucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.VIEW);
    var measureBucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.MEASURES);
    var secondaryMeasureBucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.SECONDARY_MEASURES);
    return {
        viewByItemCount: viewBucket ? sdk_model_1.bucketItems(viewBucket).length : 0,
        measureItemCount: measureBucket ? sdk_model_1.bucketItems(measureBucket).length : 0,
        secondaryMeasureItemCount: secondaryMeasureBucket ? sdk_model_1.bucketItems(secondaryMeasureBucket).length : 0,
    };
}
exports.countBucketItems = countBucketItems;
function countItemsOnAxes(type, controls, insight) {
    var _a, _b, _c, _d;
    var isBarFamilyChartType = sdk_ui_charts_1.isBarChart(type) || sdk_ui_charts_1.isBulletChart(type);
    var _e = countBucketItems(insight), viewByItemCount = _e.viewByItemCount, measureItemCount = _e.measureItemCount, secondaryMeasureItemCount = _e.secondaryMeasureItemCount;
    var totalMeasureItemCount = measureItemCount + secondaryMeasureItemCount;
    var secondaryMeasureCountInConfig = (isBarFamilyChartType
        ? (_b = (_a = controls === null || controls === void 0 ? void 0 : controls.secondary_xaxis) === null || _a === void 0 ? void 0 : _a.measures) !== null && _b !== void 0 ? _b : [] : (_d = (_c = controls === null || controls === void 0 ? void 0 : controls.secondary_yaxis) === null || _c === void 0 ? void 0 : _c.measures) !== null && _d !== void 0 ? _d : []).length;
    if (isBarFamilyChartType) {
        return {
            yaxis: viewByItemCount,
            xaxis: totalMeasureItemCount - secondaryMeasureCountInConfig,
            secondary_xaxis: secondaryMeasureCountInConfig,
        };
    }
    if (sdk_ui_charts_1.isScatterPlot(type) || sdk_ui_charts_1.isBubbleChart(type)) {
        return {
            xaxis: measureItemCount,
            yaxis: secondaryMeasureItemCount,
        };
    }
    return {
        xaxis: viewByItemCount,
        yaxis: totalMeasureItemCount - secondaryMeasureCountInConfig,
        secondary_yaxis: secondaryMeasureCountInConfig,
    };
}
exports.countItemsOnAxes = countItemsOnAxes;
//# sourceMappingURL=insightIntrospection.js.map